import { useMemo, useState } from 'react';

// 國際電話輸入：國碼下拉＋號碼自由輸入（海外港人／小B 常用海外號碼）
// value＝含國碼嘅完整數字（例 85291234567／447xxxxxxxxx）
const COUNTRY_CODES = [
  { code: '852', flag: '🇭🇰', label: '香港 +852' },
  { code: '44', flag: '🇬🇧', label: '英國 +44' },
  { code: '1', flag: '🇺🇸', label: '美國/加拿大 +1' },
  { code: '61', flag: '🇦🇺', label: '澳洲 +61' },
  { code: '65', flag: '🇸🇬', label: '新加坡 +65' },
  { code: '86', flag: '🇨🇳', label: '中國 +86' },
  { code: '353', flag: '🇮🇪', label: '愛爾蘭 +353' },
  { code: '64', flag: '🇳🇿', label: '紐西蘭 +64' },
];

interface Props {
  value: string;
  onChange: (fullDigits: string) => void;
  inputCls?: string;
  required?: boolean;
  ariaLabel?: string;
}

function splitPhone(value: string): { cc: string; num: string } {
  const digits = (value || '').replace(/\D/g, '');
  for (const c of ['852', '44', '61', '65', '353', '64', '86', '1']) {
    if (digits.startsWith(c) && digits.length > c.length) {
      return { cc: c, num: digits.slice(c.length) };
    }
  }
  return { cc: '852', num: digits };
}

export default function CountryPhoneInput({ value, onChange, inputCls = '', required, ariaLabel = 'WhatsApp 號碼' }: Props) {
  const { cc, num } = useMemo(() => splitPhone(value), [value]);
  const set = (newCc: string, newNum: string) => onChange(newCc + newNum.replace(/\D/g, ''));

  return (
    <div className="flex gap-2">
      <select
        value={cc}
        onChange={(e) => set(e.target.value, num)}
        className={`shrink-0 w-auto min-w-0 ${inputCls} pr-1 pl-2`}
        aria-label="國家／地區代碼"
      >
        {COUNTRY_CODES.map((c) => (
          <option key={c.code} value={c.code}>{c.flag} +{c.code}</option>
        ))}
      </select>
      <input
        type="tel"
        value={num}
        onChange={(e) => set(cc, e.target.value)}
        placeholder="9xxxxxxx"
        className={`flex-1 min-w-0 ${inputCls}`}
        required={required}
        inputMode="tel"
        maxLength={12}
        aria-label={ariaLabel}
      />
    </div>
  );
}
